'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceMotion = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useDeviceMotion = exports.useDeviceMotion = function useDeviceMotion() {
  var _React$useState = _react2.default.useState({
    acceleration: {
      x: null,
      y: null,
      z: null
    },
    accelerationIncludingGravity: {
      x: null,
      y: null,
      z: null
    },
    rotationRate: {
      alpha: null,
      beta: null,
      gamma: null
    },
    interval: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      motion = _React$useState2[0],
      setMotion = _React$useState2[1];

  _react2.default.useEffect(function () {
    var handle = function handle(deviceMotionEvent) {
      setMotion(deviceMotionEvent);
    };

    window.addEventListener('devicemotion', handle);

    return function () {
      window.removeEventListener('devicemotion', handle);
    };
  }, []);

  return motion;
};